<template>
  <div class="float-button-list">
    <div class="item">
      <img class="img1" src="@/assets/sfbuy/qr_code.png" alt="Image 1">
      <div class="text">{{ $t('sfbuy.wechatScane') }}</div>
      <div class="text" style="color: #DC1D32">{{ $t('sfbuy.wechatScane1') }}<br>{{ $t('sfbuy.wechatScane2') }}</div>
    </div>
    <div class="item" @click="redirectToHelper">
      <img src="@/assets/sfbuy/icon_help.png" alt="Image 2">
      <div class="text">{{ $t('sfbuy.helpCenter') }}</div>
    </div>
    <div class="item" @click="redirectToService">
      <img src="@/assets/sfbuy/online.png" alt="Image 3">
      <div class="text">{{ $t('sfbuy.onlineService') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectToHelper() {
      window.location.href = 'http://www.sfbuy.com/new/helper/toProblem'
    },
    redirectToService() {
      window.location.href = 'https://ocs2odp.sf-express.com/'
    }
  }
}
</script>

<style scoped>
  .float-button-list {
    background-color: white;
    position: fixed;
    bottom: 100px;
    right: 0;
    width: 70px;
    /*height: 322px;*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70px;
    margin-bottom: 15px;
  }

  .item:nth-child(2) {
    cursor: pointer;
  }

  .item:nth-child(3) {
    cursor: pointer;
  }

  .item img {
    width: 32px;
    height: 32px;
  }

  .img1 {
    width: 70px !important;
    height: 70px !important;
  }

  .item .text {
    width: 70px;
    color: #666666;
    margin-top: 6px;
    font-size: 12px;
    text-align: center;
    text-wrap: normal;
    line-height: 18px;
  }
</style>
